
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const whatsappMessage = encodeURIComponent("Hello 👋 The Tooth Doctor,\nI would like to book an appointment / make an enquiry about your dental services.\nPlease share available slots and details.");
  const whatsappUrl = `https://wa.me/916369090441?text=${whatsappMessage}`;

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '/about' },
    { name: 'Our Services', href: '/services' },
    { name: 'Gallery', href: '/gallery' },
    { name: 'Our Doctors', href: '/doctors' },
    { name: 'Contact', href: '/contact' }
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="bg-[#012B53] shadow-lg sticky top-0 z-50">
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-3 md:py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center flex-shrink-0">
            <img 
              src="https://static.readdy.ai/image/9921b96583d8c2e46a2d40cbefc3b198/2a288ca5d72d8af29eca8cc51eddb042.jfif" 
              alt="The Tooth Doctor - Advanced Dental Care Center"
              className="h-12 sm:h-14 md:h-16 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  isActive(item.href)
                    ? 'text-yellow-300 border-b-2 border-yellow-300 pb-1'
                    : 'text-white hover:text-yellow-300'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* CTA Buttons - Desktop */}
          <div className="hidden lg:flex items-center space-x-3 xl:space-x-4">
            <a href="tel:+916369090441" className="text-white hover:text-yellow-300 transition-colors p-2">
              <i className="ri-phone-line text-xl"></i>
            </a>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="text-green-400 hover:text-green-300 transition-colors p-2">
              <i className="ri-whatsapp-line text-xl"></i>
            </a>
            <Button size="sm" onClick={() => window.open(whatsappUrl, '_blank')} className="whitespace-nowrap">
              Book Appointment
            </Button>
          </div>

          {/* Mobile CTA Buttons */}
          <div className="flex lg:hidden items-center space-x-2 sm:space-x-3">
            <a href="tel:+916369090441" className="text-white hover:text-yellow-300 transition-colors p-2">
              <i className="ri-phone-line text-lg sm:text-xl"></i>
            </a>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="text-green-400 hover:text-green-300 transition-colors p-2">
              <i className="ri-whatsapp-line text-lg sm:text-xl"></i>
            </a>
            
            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 rounded-md text-white hover:text-yellow-300 hover:bg-white/10 ml-2"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl sm:text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-white/20">
            <nav className="flex flex-col space-y-3">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className={`text-base font-medium transition-colors duration-200 py-2 px-2 rounded ${
                    isActive(item.href) ? 'text-yellow-300 bg-white/10' : 'text-white hover:text-yellow-300 hover:bg-white/5'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              
              <div className="pt-4 border-t border-white/20 mt-4">
                <Button 
                  size="sm" 
                  fullWidth 
                  onClick={() => {
                    window.open(whatsappUrl, '_blank');
                    setIsMenuOpen(false);
                  }}
                  className="mb-3"
                >
                  <i className="ri-calendar-line mr-2"></i>
                  Book Appointment
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
